import axios from 'axios';

const CLOUD_DEFAULT_API_BASE_URL = 'https://dealmanager-backend-d3euc2f8g4g7cqch.canadacentral-01.azurewebsites.net';
const LOCAL_DEV_API_BASE_URL = 'http://localhost:8000';

const isBrowser = typeof window !== 'undefined';
const isLocalHost =
  isBrowser &&
  ['localhost', '127.0.0.1'].includes((window.location?.hostname || '').toLowerCase());

// Priority:
// 1) REACT_APP_API_BASE_URL if explicitly set
// 2) Local dev proxy (empty base URL) when running on localhost
// 3) Cloud backend fallback for deployed frontends
const isDev = process.env.NODE_ENV !== 'production';

const RAW_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || (isDev || isLocalHost ? LOCAL_DEV_API_BASE_URL : CLOUD_DEFAULT_API_BASE_URL);

// Prevent mixed-content when frontend is served over HTTPS
const API_BASE_URL =
  isBrowser && window.location?.protocol === 'https:' && RAW_API_BASE_URL.startsWith('http://')
    ? RAW_API_BASE_URL.replace(/^http:\/\//i, 'https://')
    : RAW_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const skipAuthRedirect = Boolean(error.config?.skipAuthRedirect);
    if (error.response?.status === 401 && !skipAuthRedirect) {
      localStorage.removeItem('access_token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
